import type { DiscountCalculator } from './DiscountCalculator';
import type { DiscountPercentage } from '@/modules/store/models/Discount';
import type { Amount, CalculatedPrice, Price } from '@/modules/store/models/Price';
import { roundPayableAmount, roundUnitPrice } from '@/utils/currency/roundPrice';

export class PercentageDiscountCalculator implements DiscountCalculator<DiscountPercentage> {
  isApplicable(quantity: number, discount: DiscountPercentage): boolean {
    return (
      (!discount.quantityFrom || quantity >= discount.quantityFrom) &&
      (!discount.quantityTo || quantity <= discount.quantityTo)
    );
  }

  calculate(originalPrice: Price, quantity: number, discount: DiscountPercentage): CalculatedPrice {
    const originalAmount = originalPrice.price;
    const unitPrice = roundUnitPrice(originalAmount.amount);
    const originalLineAmount = roundPayableAmount(quantity * unitPrice);

    if (!this.isApplicable(quantity, discount)) {
      return {
        ...originalAmount,
        amount: originalLineAmount,
        originalPrice: { ...originalAmount, amount: originalLineAmount },
        discountedPrice: { ...originalAmount, amount: originalLineAmount },
        discountPercentage: discount,
      };
    }

    const discountedUnitPrice = roundUnitPrice(unitPrice * (1 - discount.percentage / 100));

    const discountedPrice: Amount = {
      currencyCode: originalAmount.currencyCode,
      amount: roundPayableAmount(quantity * discountedUnitPrice),
    };

    return {
      ...discountedPrice,
      originalPrice: { ...originalAmount, amount: originalLineAmount },
      discountedPrice,
      discountPercentage: discount,
    };
  }
}
